import { CallsInfo } from "@/components/Portal/Cockpit/CallsInfo/CallsInfo.tsx";
import { RoamingUsage } from "@/components/Portal/Cockpit/RoamingUsage/RoamingUsage.tsx";
import { DeviceProductCard } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/DeviceProductCard.tsx";
import { getIconForProductCategory } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/ProductCategoryIcon.tsx";
import { SimStatusChip } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceProductCard/SimStatusChip.tsx";
import { ExtendedSimCardDetail } from "@/hooks/useExtendedSims.ts";
import { useGetTitle } from "@/hooks/useGetTitle.ts";
import { getFlatNameFromDevice } from "@/utils/deviceUtils";

interface ActiveSimTileProps {
  device: ExtendedSimCardDetail;
  manageRoute: string;
}

export const ActiveSimTile = ({ device, manageRoute }: ActiveSimTileProps) => {
  const icon = getIconForProductCategory(device);
  const title = useGetTitle(device.alias);

  return (
    <DeviceProductCard
      dataTestid="active-sim"
      icon={icon}
      title={title}
      subtitle={getFlatNameFromDevice(device)}
      navigationTarget={`${manageRoute}?simId=${device.simId}`}
      chips={<SimStatusChip status={device.simStatus} />}
      footer={
        <div className="flex w-full flex-col gap-3">
          <CallsInfo device={device} />
          <RoamingUsage device={device} />
        </div>
      }
    />
  );
};
